module.exports = __webpack_public_path__ + "static/c-f7e08b5f21ab0a9716fb933ede97c08e.png";